import { createSelector } from 'reselect';

import { EListingSource } from '@/services/analytics/listings/types';
import { IRentalTile, mapRentalsToTiles } from '@/utility/mapSearchResultToTile';

import { TRootState } from '../rootReducer';
import { getUserFavorites } from './favorites';

type TListingsData = TRootState['bundledListings'];
type TLoadingListingData = TRootState['bundledListings']['isLoading'];

export const getBundledListings = createSelector<
  TRootState,
  ReturnType<typeof getUserFavorites>,
  TListingsData,
  TRootState['queryParams'],
  TRootState['searchForm'],
  IRentalTile[]
>(
  getUserFavorites,
  state => state.bundledListings,
  state => state.queryParams,
  state => state.searchForm,
  (favorites, { data, isLoading }, queryParams, searchForm) => {
    return mapRentalsToTiles({
      rentals: data || [],
      favorites,
      loading: isLoading,
      hasImageCarousel: true,
      queryParams,
      searchForm,
      listingSource: EListingSource.VACATION_PACKAGES,
    });
  },
);

export const isLoadingBundledListingsData = createSelector<
  TRootState,
  TLoadingListingData,
  boolean
>(
  state => state.bundledListings.isLoading,
  data => data,
);
